import React from 'react';
import styled from '@emotion/styled';
import { SignupFlow } from 'corgi-types';
import { display } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { useLoginUrl } from 'common/hooks/form/login';
import { useLocalization } from 'common/providers/LocaleProvider';
import { HomeClubSectionEventName, HomeClubSectionEventPlacement } from 'common/tracking/home-club';
import type { BaseComponentProps } from '../../types';
import BaseCTAButton from '../shared/BaseCTAButton';
import FixedBottomContainer from './FixedBottomContainer';

interface ContentSubmitButtonProps extends BaseComponentProps {
  handleModalOpen?: () => void;
}

const BottomContainer = styled(Flex)<any>`
  ${display};
`;
const bottomContainerStyles = {
  display: ['none', null, 'flex'],
  justifyContent: 'center',
};

const ContentSubmitButton = ({
  isLoggedIn,
  trackingProps,
  handleModalOpen,
}: ContentSubmitButtonProps) => {
  const { t } = useLocalization();
  const loginURL = useLoginUrl(SignupFlow.ContentHomeClub);
  const buttonLabel = t('h24_hc_submit_btn_label');

  const onButtonClick = () => {
    if (!isLoggedIn) {
      window.location.href = loginURL;

      return;
    }

    handleModalOpen();
  };

  const CTAButton = (
    <BaseCTAButton
      tracking={{
        eventName: trackingProps?.eventName ?? HomeClubSectionEventName.Click,
        placement: HomeClubSectionEventPlacement.Inline,
        text: buttonLabel,
        ...trackingProps,
      }}
      onClick={onButtonClick}
    >
      {buttonLabel}
    </BaseCTAButton>
  );

  return (
    <>
      <FixedBottomContainer>{CTAButton}</FixedBottomContainer>
      <BottomContainer {...bottomContainerStyles}>{CTAButton}</BottomContainer>
    </>
  );
};

export default ContentSubmitButton;
